import React from 'react';
import {
  Box,
  Flex,
  Heading,
  VStack,
} from '@chakra-ui/react';
import IntakeConfig from '../../interfaces/IntakeConfig.interface';
import InputField from './form/InputField';
import TextAreaField from './form/TextAreaField';
import {
  State,
} from './state';
import SelectField from './form/SelectField';
import { required } from './form/validators';

type QuestionElement = State['form']['questions'][number];

const Question = ({
  questionKey, question,
}: {
  questionKey: string,
  question: QuestionElement
}) => {
  if (question.type === 'select') {
    return (
      <>
        <SelectField
          label={question.label}
          name={`questions.${questionKey}.response`}
          validate={question.required ? required('Required') : undefined}
        >
          {
            question.options?.map((op) => (
              <option value={op.value} key={op.value}>{op.label}</option>
            ))
          }
        </SelectField>
      </>
    );
  }

  if (question.type) {
    return (
      <InputField
        label={question.label}
        name={`questions.${questionKey}.response`}
        validate={question.required ? required('Required') : undefined}
        type={question.type}
        placeholder={question.placeholder}
        maxLength={512}
        maxW={question.type === 'color' ? '250px' : 'unset'}
      />
    );
  }

  return (
    <TextAreaField
      label={question.label}
      name={`questions.${questionKey}.response`}
      validate={question.required ? required('Required') : undefined}
      placeholder={question.placeholder}
      maxLength={2048}
      h="7lh"
    />
  );
};

const QuestionsView = ({
  config,
}: {
  config: IntakeConfig,
}): JSX.Element => {
  const { questions } = config;

  return (
    <fieldset>
      <legend>
        <Heading fontSize="2xl" mb={6}>Product / Service Details</Heading>
      </legend>
      {/* @ts-ignore */}
      <VStack spacing={5} align="stretch">
        {Object.entries(questions).map(
          ([questionKey, question]) => (
            <Flex w="100%" gap={{ base: '0.5em', lg: '2em'}} wrap={{ base: "wrap", lg: 'nowrap'}}>
              <Flex width={{ base: '100%', lg: '66%' }}>
                <Question
                  key={questionKey}
                  questionKey={questionKey}
                  question={question}
                />
              </Flex>
            </Flex>
          ),
        )}
        <Box width={{ base: '100%', lg: '66%' }}>
          <SelectField
            name="contact.onboardingPreference"
            label="Onboarding Preference"
          >
            <option value="email">Email</option>
            <option value="video">Video Call</option>
          </SelectField>
        </Box>
      </VStack>
    </fieldset>
  );
};

export default QuestionsView;
